import $ from "jquery";
import "slick-carousel";

var carouselArrows = document.querySelector("[data-carousel-arrows=timeline]");
var hiddenElem = document.querySelector(".timeline-nav__item-content.hidden");
var prevArrow = `
  <button type="button" data-role="none" class="slick-prev slick-arrow slick-disabled" aria-label="Previous" role="button" aria-disabled="true" style="display: block;">
    <svg width="19" aria-label="Previous" height="30" viewBox="0 0 19 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.5254 3.525L7.07539 15L18.5254 26.475L15.0004 30L0.000394225 15L15.0004 -3.08165e-07L18.5254 3.525Z" fill="#014841"/></svg>  
  </button>`;
var nextArrow = `
  <button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: block;" aria-disabled="false">
    <svg width="19" height="30" viewBox="0 0 19 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.474609 26.475L11.9246 15L0.474609 3.525L3.99961 0L18.9996 15L3.99961 30L0.474609 26.475Z" fill="#014841"/></svg>  
  </button>`;

$(".timeline-nav").slick({
  slidesToShow: 6,
  slidesToScroll: 6,
  asNavFor: ".timeline-slider",
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
  infinite: false,
});

$(".timeline-slider").on("init", function (event, slick) {
  hiddenElem.innerHTML = document.querySelector(
    ".timeline-nav__item.slick-slide.slick-current .timeline-nav__item-content",
  ).innerHTML;
});

$(".timeline-slider")
  .slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    appendArrows: carouselArrows,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    asNavFor: ".timeline-nav",
    speed: 500,
    infinite: false,
  })
  .on("afterChange", function (event, slick, currentSlide, nextSlide) {
    hiddenElem.innerHTML = document.querySelector(
      ".timeline-nav__item.slick-slide.slick-current .timeline-nav__item-content",
    ).innerHTML;
  });

document
  .querySelectorAll(".our-story-slider h3")
  .forEach(function (el, currentIndex) {
    el.addEventListener("click", function () {
      document
        .querySelectorAll(".our-story-slider h3")
        .forEach(function (elem) {
          if (elem.classList.contains("active--heading")) {
            elem.classList.remove("active--heading");
          }
        });
      el.classList.add("active--heading");
      document.querySelectorAll("[data-tab-index]").forEach(function (item) {
        if (item.classList.contains("active--item")) {
          item.classList.remove("active--item");
        }
      });
      document
        .querySelector(`[data-tab-index="index-${currentIndex}"]`)
        .classList.add("active--item");
    });
  });
